import { ApiClient } from '../../global.d';
import OKTA_CONFIG from '../constants/oktaConfig';

const TransactionRouterService = async () => {
  const oktaStorage = localStorage.getItem(OKTA_CONFIG.oktaTokenStorage);
  const oktaAccessToken = JSON.parse(oktaStorage ?? '{}')?.accessToken
    ?.accessToken;

  return new ApiClient({
    baseURL: process.env.REACT_APP_TRANSACTION_ROUTER_HOST,

    headers: {
      authorization: `Bearer ${oktaAccessToken}`
    }
  });
};

export default TransactionRouterService;
